const parseJudgeMeRatings = (section) => {
  const reviewContainers = section.querySelectorAll('[data-combo-reviews]');

  for (const container of reviewContainers) {
    const badgeHTML = container.dataset.judgemeBadge;
    if (!badgeHTML) continue;

    const parser = new DOMParser();
    const doc = parser.parseFromString(badgeHTML, 'text/html');
    const badge = doc.body.firstChild;
    if (!badge) continue;

    const avgRating = parseFloat(badge.dataset.averageRating ?? 0).toFixed(1);
    const reviewCount = badge.dataset.numberOfReviews ?? '0';

    const avgEl = container.querySelector('[data-avg-rating]');
    const countEl = container.querySelector('[data-reviews-count]');

    if (avgEl) avgEl.textContent = avgRating;
    if (countEl) countEl.textContent = `(${reviewCount})`;
  }
};

const activateComboCard = (card, section) => {
  card.classList.add('collapsable-combo-section__card--active');

  const { comboVariantId = '', comboPrice = '', comboComparePrice = '' } = card.dataset;

  const variantInput = section.querySelector('[data-combo-variant-input]');
  if (variantInput) variantInput.value = comboVariantId;

  // Amounts are pre-formatted by Liquid — JS only copies the strings across.
  const priceEl = section.querySelector('[data-combo-atc-price]');
  const priceAmountEl = section.querySelector('[data-combo-atc-price-amount]');
  if (priceEl && priceAmountEl) {
    priceAmountEl.textContent = comboPrice;
    priceEl.hidden = comboPrice === '';
  }

  const compareEl = section.querySelector('[data-combo-atc-compare]');
  const compareAmountEl = section.querySelector('[data-combo-atc-compare-amount]');
  if (compareEl && compareAmountEl) {
    compareAmountEl.textContent = comboComparePrice;
    compareEl.hidden = comboComparePrice === '';
  }
};

const initComboSection = (section) => {
  if (section.dataset.comboInitialized) return;
  section.dataset.comboInitialized = 'true';

  const cards = section.querySelectorAll('[data-combo-card]');

  parseJudgeMeRatings(section);

  // Default to the second card (the "popular" one), falling back to the only card.
  const defaultCard = cards[1] ?? cards[0];
  if (defaultCard) activateComboCard(defaultCard, section);

  for (const card of cards) {
    card.addEventListener('click', () => {
      for (const c of cards) c.classList.remove('collapsable-combo-section__card--active');
      activateComboCard(card, section);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-section="collapsable-combo-section"]').forEach(initComboSection);
});

if (!window.__comboSectionObserverLoaded) {
  window.__comboSectionObserverLoaded = true;

  let comboObserverTimer;
  const comboObserver = new MutationObserver(() => {
    clearTimeout(comboObserverTimer);
    comboObserverTimer = setTimeout(() => {
      document.querySelectorAll('[data-section="collapsable-combo-section"]').forEach(initComboSection);
    }, 50);
  });

  // Scope to body (not documentElement) to avoid watching <html> attribute changes
  comboObserver.observe(document.body, { childList: true, subtree: true });

  // On the live storefront, disconnect after the page has fully settled.
  // In the theme editor (designMode) we keep it running so section re-ordering works.
  if (!Shopify.designMode) {
    window.addEventListener('load', () => {
      setTimeout(() => comboObserver.disconnect(), 3000);
    }, { once: true });
  }
}
